import axios from 'axios'
import { toast } from 'sonner'
import { useAuthStore } from '../stores/authStore'

export const api = axios.create({
  baseURL: '',
  headers: {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  },
  withCredentials: true,
})

// Request interceptor
api.interceptors.request.use((config) => {
  const token = useAuthStore.getState().token
  if (token && !config.headers?.Authorization) {
    config.headers = config.headers || {}
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

// Response interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (axios.isCancel(error)) return Promise.reject(error)
    if (error?.response?.status === 401) {
      useAuthStore.getState().logout()
      // Don't redirect if already on login page
      if (!window.location.pathname.startsWith('/login') && !window.location.pathname.startsWith('/auth')) {
        window.location.href = '/login'
      }
    } else {
      // Global error notification
      const detail = error?.response?.data?.detail
      if (detail) {
        toast.error(typeof detail === 'string' ? detail : JSON.stringify(detail))
      } else if (error?.message) {
        // Only show generic network errors if we don't have a specific detail
        // unless it's a 404 which might just be an empty result, depending on context.
        if (error?.response?.status !== 404) {
            toast.error(`Ошибка сети: ${error.message}`)
        }
      }
    }
    return Promise.reject(error)
  }
)

export default api

